/**
 * RESPONSIBILITY: draw the Bulletin page — this week's on top, earlier weeks below by date.
 *
 * The page the menu and a printed QR code can point at for good: its address never
 * changes, only what it shows. Each bulletin opens in a new tab, as on the home page.
 */
import type { BulletinSection } from '@app/sections';
import { PageHead } from '../commons/PageHead';
import { useBulletins, isThisWeeks, bulletinHref } from './useBulletins';
import { bulletinDay } from './bulletin-day';

export function BulletinView({ c }: { c: BulletinSection }) {
  const [latest, ...earlier] = useBulletins(c.folderUrl);

  return (
    <>
      <PageHead eyebrow={c.eyebrow} heading={c.heading} intro={c.intro} />
      <section className="band">
        <div className="wrap bulletin-wrap">
          {!latest && c.emptyText && <p className="lede">{c.emptyText}</p>}
          {latest && (
            <div className="bulletin-current">
              <span className="eyebrow">{isThisWeeks(latest) ? c.currentLabel : c.latestLabel}</span>
              <h2>{latest.date ? bulletinDay(latest.date) : latest.title}</h2>
              {c.openLabel && (
                <a className="btn" href={bulletinHref(latest)} target="_blank" rel="noopener">
                  {c.openLabel}
                </a>
              )}
            </div>
          )}
          {earlier.length > 0 && (
            <div className="bulletin-past">
              {c.pastHeading && <h3>{c.pastHeading}</h3>}
              <ul>
                {earlier.map((b) => (
                  <li key={b.id}>
                    <a href={bulletinHref(b)} target="_blank" rel="noopener">
                      {b.date ? bulletinDay(b.date) : b.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
